import React, { useContext, useEffect, useState } from "react";
import HomeCounters from "./Homecounters";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import Footer from "./footer";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";

function MSMEregistration() {

   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setNewData((prevData) => ({
          ...prevData,
          user_name: parsedUser.name || "",
          user_email_address: parsedUser.email || "",
          user_phone_number: parsedUser.mobile || "",
   
        }));
      }
    }, []);

     const { http, token } = AuthUser();
   const navigate = useNavigate();

   const [activeQuestion, setActiveQuestion] = useState(null);

   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };

    const[newData,setNewData]=useState({user_name:'',user_email_address:'',user_phone_number:'',user_category:''})
   
      const [errors, setErrors] = useState({});

         const { services, loading, error } = useContext(ServicesContext);  
         if (loading) {
            return <div>Loading...</div>;  // Show loading state while fetching data
        }
      
        if (error) {
             return <div>{error}</div> // Show error state if there was an issue fetching data
        }
         const service = services.find(s => s.service_id === 10);
   
      const validateForm = () => {
         const newErrors = {};
   
         // Name validation
         if (!newData.user_name.trim()) {
            newErrors.user_name = 'Name is required.';
         }   else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
            newErrors.user_name = '*Name should only contain letters and spaces.';
          }
   
         // Email validation
         if (!newData.user_email_address.trim()) {
            newErrors.user_email_address = 'Email is required.';
         } else if (!/\S+@\S+\.\S+/.test(newData.user_email_address)) {
            newErrors.user_email_address = 'Enter a valid email address.';
         }
   
         // Phone number validation
         // if (newData.user_phone_number && !/^\d{10}$/.test(newData.user_phone_number)) {
         //    newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
         // }

         if (!newData.user_phone_number.trim()) {
            newErrors.user_phone_number = 'number is required.';
          } else if (!/^\d{10}$/.test(newData.user_phone_number)) {
            newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
          }
   
   
         // Category validation
         if (!newData.user_category) {
            newErrors.user_category = 'Please select a category.';
         }
   
         setErrors(newErrors);
         return Object.keys(newErrors).length === 0; // Return true if no errors
      };
   


    const formPutPartenshipdeed = async (e) => {
                e.preventDefault();
                    // ✅ Check if user is logged in
       // if (!token) {
      //     alert("Please log in to continue.");
      //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      //    navigate('/login'); // 👈 Use this if you're using React Router
      //    return;
      // }
                if (!validateForm()) return;
              
                localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });
                 
              };

   return (
      <div>

         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <p className="pdrl-text"><img src="assets/img/image/Line.png" className="line-image" /> <span className="text-color">250k+</span> <span>People trust us</span></p>
                        <h1 className="sk-text-color">MSME Registration</h1>
                        <p className="pdrl-text">Get MSME Registration for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                        <p className="pd-text">Take advantage of the benefits offered under the MSME Act by registering yourself with Udyog Aadhaar or MSME Registration, and access support from both the Central and State Governments, as well as the banking sector.</p>
                        <div className="banner">
                           <img src="assets/icons/banner.svg" alt="" srcset="" />
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>MSME Registration
</h3> <p className="pdrl-text">at Rs.{service?.price}/- Only <br/> <span>(Final Price, No Hidden Costs)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Email Address<span className="red">*</span></label> {errors.user_email_address && <p className="error-text">{errors.user_email_address}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email_address} onChange={(e) => setNewData({ ...newData, user_email_address: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Contact Number<span className="red">*</span></label> {errors.user_phone_number && <p className="error-text">{errors.user_phone_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_phone_number} onChange={(e) => setNewData({ ...newData, user_phone_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                       <label for="" className="dropdown-text">Category<span className="red">*</span></label> {errors.user_category && <p className="error-text">{errors.user_category}</p>}
                                       <div className="niceSelect">
                                       <select className="wide" onChange={(e) => setNewData({ ...newData, user_category: e.target.value })} value={newData.user_category}>
                                             <option className="formop" data-display="Select Category...">Select Category...</option>
                                             <option value="Sole Proprietorship / Individual">Sole Proprietorship / Individual</option>
                                             <option value="Partnership / LLP">Partnership / LLP</option>
                                             <option value="Private limited / Public limited / One person company">Private limited / Public limited / One person company</option>
                                             <option value="HUF">HUF</option>
                                             <option value="Society / Trust / Club">Society / Trust / Club</option>
                                          </select>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>


               <div className="space40"></div>
               <div className="row">
                  <div className="col-lg-12">
                     <p className="pd-text">Are you launching your business soon? Registering under the MSME Act can give your venture a competitive edge!

MSMEs are the backbone of the Indian economy, and the Ministry of Micro, Small, and Medium Enterprises provides numerous incentives to boost their growth. By registering under the MSME Act, you unlock a range of benefits, including:
<br/>
✅ Government Support – Avail subsidies and incentives from Central & State Governments. <br/>
✅ Easier Access to Credit – Secure pre-approved loans with lower interest rates. <br/>
✅ Legal Compliance – MSME registration is mandatory for businesses operating in India. <br/>

Let Dm2Legal assist you in obtaining your MSME registration while guiding you through government schemes and transparent processes.<br/>

📞 Get in touch today and take your business to new heights!</p>
                  </div>
               </div>
              

            </div>
         </div>



         <div className="service-binifits9 bg-white" >
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">How to apply</h2>
                        <div className="space20"></div>
                        <img src="assets/img/images/MSME-Registration.png" />
                     </div>
                     <div className="space20"></div>
                  </div>
               </div>
            </div>
         </div>
         <div className="space20 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">

                        <h2 className="text-center">Importance of MSME Registration for Small Businesses </h2>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Access to Credit</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Limited Liability Partnerships</li>
                            
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Market Access and Economic Growth</li>
                              
                           </ul>
                        </div>
                     </div>
                  </div>

                  <div className="col-lg-4">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <div className="contact6-list">
                           <ul>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Simplified Compliance</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Intellectual Property Rights</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Tax Exemptions</li>
                             
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-3">
                     <img src="assets/img/images/Importance-of-MSME-Registration-for-Small-Businesses-[Converted].png" alt="" />
                  </div>
               </div>
               <div className="space30"></div>

             
            </div>
         </div>

         <div className="service-binifits9 sp0" id="service2" >
            <div className="space40"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Common Mistakes to Avoid in MSME Registration  </h2>
                        <div className="service-binifits-boxs">
                           <div className="row">
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                           Incorrect Company Names</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                           Not drafting and registering the written rental agreement</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                           Incorrect Company Type</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                           The absence of founders/Shareholder's agreement</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                           Incorrect company description</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                           No thorough information on the local laws.</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                           Incorrect Supporting Documents</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                           Incorrect Office Address</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                           Unnecessary appointment of Directors</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-6">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                           Not seeking professional help</p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
            </div>
         </div>

         <div className="bg-white">

            <div className="container">


               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Benefits of Online IEC License Application with Dm2Legal</h2>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
               <div className="row">
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-9.png" alt="" />
                        </div>
                        <h3>Collateral-free Bank Loans</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-10.png" alt="" />
                        </div>
                        <h3>Access to International Trade</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Reduced Rate of Interest from Banks</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-12.png" alt="" />
                        </div>
                        <h3>Subsidy on Patent Registration</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-13.png" alt="" />
                        </div>
                        <h3>Tax Exemption</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-14.png" alt="" />
                        </div>
                        <h3>Protection against Delayed Payments</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-15.png" alt="" />
                        </div>
                        <h3>Electricity Bill Concessions</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Reimbursement of ISO Certification</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-11.png" alt="" />
                        </div>
                        <h3>Marketing and Promotion Assistance</h3>
                     </div>
                  </div>
                  {/* <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Technology Upgradation support to MSME</h3>
                     </div>
                  </div> */}
               </div>



            </div>
         </div>


         <div className="service-binifits9 sp0" id="service2">
            <div className="container work8">
               <div className="row">
                  <div className="col-lg-12 text-center">
                     <div className="hadding7">
                        <div className="space80"></div>
                        <h2 className="aos-init aos-animate">Online Application for MSME Registration </h2>
                     </div>
                     <div className="partnership-deade-section">
                        <div className="space40"></div>

                        <ul className="disc-list">
                           <li><h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>To ensure you are risk-free, our team will carefully review your submitted documents for any incorrect or misleading information.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our professionals are here to assist you with document requirements and licensing needs.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>After filling out the application form, a confirmation will appear on the screen along with the reference number.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>We recommend waiting until one of our experts contacts you to inform you that your certificate is ready. You can then download the MSME certificate from the account created on the Udyam portal.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                              <span>We will also provide you with a reference number so you can track the status of your application.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                        </ul>

                        <div className="space80"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space4  0 bg-white"></div>
         <div className="bg-white">

            <div className="container ">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <p>&nbsp;</p>
                        <h2 className="text-center">The Process of MSME Registration Online  </h2>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong>Step 1:</strong>
                                 <div className="space20"></div>
                                 <p className="pd-text">Visit the Udyam Registration portal of the Ministry of Micro, Small, and Medium Enterprises (MSME).</p>
                              </li>
                              <hr/>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong>Step 2:</strong>
                                 <div className="space20"></div>
                                 <p className="pd-text">Before proceeding, check the eligibility criteria to ensure your business qualifies. This is based on investment in plant and machinery or equipment, as well as annual turnover.</p>
                              </li>
                              <hr/>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong>Step 3:</strong>
                                 <div className="space20"></div>
                                 <p className="pd-text">Gather Required Information Prepare the following details and documents before starting the registration process:</p>
                                 <ul>
                                    <li>• Aadhaar Card</li>
                                    <li>• PAN (Permanent Account Number) of the business</li>
                                    <li>• Business name, type and location.</li>
                                    <li>• Contact details</li>
                                    <li>• Bank account details</li>
                                    <li>• NIC code (National Industrial Classification) of your business activity</li>
                                 </ul>
                              </li>
                              <hr/>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong>Step 4:</strong>
                                 <div className="space20"></div>
                                 <p className="pd-text">Follow these steps to register :</p>
                                 <ul>
                                    <li>• Click on link - "For New Entrepreneurs who are not Registered yet as MSME".</li>
                                    <li>• Enter the Aadhaar number of the business owner or authorized signatory.</li>
                                    <li>• Click "Validate and Generate OTP." You will receive an OTP on registered mobile number linked to your Aadhaar. Enter OTP for verification.</li>
                                    <li>• Provide the necessary business details, including PAN, business name, location, NIC code and other information.</li>
                                    <li>• Enter your bank account details.</li>
                                    <li>• Review the information provided and click on the "Submit" button.</li>
                                 </ul>
                              </li>
                              <hr/>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong>Step 5:</strong>
                                 <div className="space20"></div>
                                 <p className="pd-text">After submitting the application, you receive an acknowledgement receipt</p>
                              </li>
                              <hr/>
                              <li className="font-f-7 step-font-size">
                                 <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong>Step 6:</strong>
                                 <div className="space20"></div>
                                 <p className="pd-text">Your MSME certificate will be generated</p>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>


               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FAQs about MSME Registration </h2>
                              <div className="space20"></div>
                              <div id="general">


                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1. Is MSME registration compulsory?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       No, MSME registration is optional, but it offers benefits like tax rebates, loan subsidies, and government schemes                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2.Can an MSME change its registration category?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, an MSME can upgrade or downgrade its classification based on changes in investment and turnover as per MSME guidelines.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3. Is there protection for MSMEs against delayed payments?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, MSMEs can seek help under the MSME Samadhaan scheme, which allows them to file complaints against delayed payments for faster resolution                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4.Is MSME registration available for trading companies?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       No, trading companies are not eligible for MSME registration, as it is meant for manufacturing and service-based businesses only                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5.How to verify an MSME certificate?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       You can verify the authenticity of an MSME certificate by checking the Udyam Registration portal or by contacting the relevant government authorities.
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6. Can an MSME get benefits from both central and state governments?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, MSMEs can avail incentives and schemes from both central and state governments, including subsidies, tax benefits, and financial support.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7.How is MSME registration different from Udyog Aadhaar?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Udyog Aadhaar was the previous MSME registration system, which is now replaced by Udyam Registration, the latest MSME registration process                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8. Do MSMEs get special benefits for exports?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, MSMEs enjoy export incentives, subsidies, and participation in trade fairs, along with benefits under schemes like MEIS and Export Promotion Capital Goods (EPCG).                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(9)}
                                    >
                                       Q9. Is a patent subsidy available for MSMEs?
                                       <span>
                                          {activeQuestion === 9 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, MSMEs can apply for a patent subsidy under the Intellectual Property Rights (IPR) scheme, which offers financial assistance for patent registration.                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(10)}
                                    >
                                       Q10. Is a physical office required for MSME registration?
                                       <span>
                                          {activeQuestion === 10 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       No, MSME registration can be done using a residential or commercial address, and a separate physical office is not mandatory                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 11 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(11)}
                                    >
                                       Q11. When will I get the MSME certificate after registration?
                                       <span>
                                          {activeQuestion === 11 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 11 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       The MSME certificate is usually issued instantly after successful Udyam Registration, but it may take 1-2 days in some cases                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 12 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(12)}
                                    >
                                       Q12. What if an MSME exceeds its investment or turnover limit?
                                       <span>
                                          {activeQuestion === 12 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 12 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       If an MSME surpasses the defined investment or turnover limits, it will be reclassified into the next applicable category as per MSME guidelines.                                       </p>
                                    </div>
                                 </div>









                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

            </div>


            <Testimonials />




            <div className="sp2 last-section bg-white">
               <div className="container">
                  <div className="row">
                     <div className="col-lg-7 m-auto text-center">
                        <div className="hadding7">

                           <h2>Why Choose Dm2Legal for MSME Registration?</h2>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
                  <div className="row">
                     <div className="col-lg-6">
                        <div className="service6-box">
                           <div className="">
                              <div className="service-box-icon">
                                 <p>1</p>
                              </div>
                           </div>
                           <div className="hadding6">
                              <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="#" >Convenient Registration</a></h4>
                              <p>With Dm2Legal, users can easily register online by providing their name, email ID, contact number, and selecting MSME registration services. After completing your online registration, our team will reach out to you and proceed with the necessary steps.</p>
                           </div>
                        </div>
                     </div>
                     <div className="col-lg-6">
                        <div className="service6-box">
                           <div className="">
                              <div className="service-box-icon">
                                 <p>2</p>
                              </div>
                           </div>
                           <div className="hadding6">
                              <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="#" >Best Online Platform</a></h4>
                              <p>Dm2Legal has one of the largest online client bases, making us one of the best online platforms in India to help you obtain your MSME registration quickly. No matter where you are, we are ready to serve you online.</p>
                           </div>
                        </div>
                     </div>
                     <div className="col-lg-6">
                        <div className="service6-box">
                           <div className="">
                              <div className="service-box-icon">
                                 <p>3</p>
                              </div>
                           </div>
                           <div className="hadding6">
                              <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="#" >Best Customer Support</a></h4>
                              <p>The Dm2Legal team is well-known for providing comprehensive support and assistance to our clients. We not only assist you after your registration is completed but also value your feedback.</p>
                           </div>
                        </div>
                     </div>
                     <div className="col-lg-6">
                        <div className="service6-box">
                           <div className="">
                              <div className="service-box-icon">
                                 <p>4</p>
                              </div>
                           </div>
                           <div className="hadding6">
                              <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="#" >Experienced Team</a></h4>
                              <p>With 10 years of experience in the industry, we are highly skilled in MSME registration. By choosing us, you'll benefit from working with top experts, ensuring a smooth and efficient registration process.</p>
                           </div>
                        </div>
                     </div>
                     <div className="col-lg-6">
                        <div className="service6-box">
                           <div className="">
                              <div className="service-box-icon">
                                 <p>5</p>
                              </div>
                           </div>
                           <div className="hadding6">
                              <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="#" >On-time Service</a></h4>
                              <p>Our team is always ready to provide timely service. We understand the value of your time, so we begin working on your MSME registration process immediately, without any delays.</p>
                           </div>
                        </div>
                     </div>
                     <div className="col-lg-6">
                        <div className="service6-box">
                           <div className="">
                              <div className="service-box-icon">
                                 <p>6</p>
                              </div>
                           </div>
                           <div className="hadding6">
                              <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="#" >Pocket-friendly Services</a></h4>
                              <p>We offer affordable services without compromising on quality. With every investment you make with us, we ensure that your satisfaction and budget are our top priorities.</p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div className="space40 bg-white"></div>

            <WhatsAppScrollButton />
            <Footer />
            <CircularScrollProgress />
         </div>
      </div>

   );
}

export default MSMEregistration;